import { FormControl, FormGroup } from '@angular/forms';
import { State } from 'src/app/interfaces/state';

export class AddressForm extends FormGroup<{
  id: FormControl<number | undefined>;
  CompanyId: FormControl<null | number>;
  VendorId: FormControl<null | number>;
  ExemptVendorId: FormControl<null | number>;
  ClientRegisteredVendorId: FormControl<null | number>;
  ApVendorId: FormControl<null | number>;
  SiteId: FormControl<null | number>;
  ContactId: FormControl<null | number>;
  OwnerId: FormControl<null | number>;
  CompanyOfficeId: FormControl<null | number>;
  LicenseId: FormControl<null | number>;
  isMailing: FormControl<boolean>;
  isStreet: FormControl<boolean>;
  isRemitTo: FormControl<boolean>;
  country: FormControl<'US' | 'CA' | undefined>;
  address1: FormControl<string | undefined>;
  address2: FormControl<string | null>;
  city: FormControl<string | undefined>;
  state: FormControl<State | undefined>;
  zip: FormControl<string | undefined>;
  latitude: FormControl<string | undefined>;
  longitude: FormControl<string | undefined>;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined, { nonNullable: true }),
      CompanyId: new FormControl<null | number>(null),
      VendorId: new FormControl<null | number>(null),
      ExemptVendorId: new FormControl<null | number>(null),
      ClientRegisteredVendorId: new FormControl<null | number>(null),
      ApVendorId: new FormControl<null | number>(null),
      SiteId: new FormControl<null | number>(null),
      ContactId: new FormControl<null | number>(null),
      OwnerId: new FormControl<null | number>(null),
      CompanyOfficeId: new FormControl<null | number>(null),
      LicenseId: new FormControl<null | number>(null),
      isMailing: new FormControl<boolean>(false, { nonNullable: true }),
      isStreet: new FormControl<boolean>(false, { nonNullable: true }),
      isRemitTo: new FormControl<boolean>(false, { nonNullable: true }),
      country: new FormControl<'US' | 'CA' | undefined>(undefined, {
        nonNullable: true
      }),
      address1: new FormControl<string | undefined>(undefined, {
        nonNullable: true
      }),
      address2: new FormControl<string | null>(null),
      city: new FormControl<string | undefined>(undefined, {
        nonNullable: true
      }),
      state: new FormControl<State | undefined>(undefined, {
        nonNullable: true
      }),
      zip: new FormControl<string | undefined>(undefined, {
        nonNullable: true
      }),
      latitude: new FormControl<string | undefined>(undefined, {
        nonNullable: true
      }),
      longitude: new FormControl<string | undefined>(undefined, {
        nonNullable: true
      })
    });
  }
}
